import React from 'react';
import SimpleCard from '../../../components/Card/SimpleCard';
import ErrorStateWithReload from '../../../components/ErrorStateWithReload';

const SectionError = () => (
  <SimpleCard>
    <ErrorStateWithReload />
  </SimpleCard>
);

export default SectionError;
